import { render, staticRenderFns } from "./public-posting.vue?vue&type=template&id=76e6522a&"
import script from "./public-posting.vue?vue&type=script&lang=js&"
export * from "./public-posting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports